import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import CryptoListDisplay from './CryptoListDisplay';
import '../../css/blink.css';

class CryptoWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Crypto/Bitcoin Screener</title> 
          <link rel="canonical" href="https://www.vizfm.com/crypto" />
          <meta name="description" content="Crypto/Bitcoin Screener for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <Col xs={3} sm={3} md={2} lg={1} xl={1}>
              <div className="waitingForConnection3">
                Live <i className="fa fa-asterisk"></i>
              </div>
            </Col>
            <Col xs={9} sm={9} md={10} lg={11} xl={11}>Crypto Currencies Screener</Col></Row>
          <Row>
            <Col><CryptoListDisplay /></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default CryptoWrap;
